import React, { useCallback, useEffect, useMemo,useRef } from 'react';
import {
  NavigationContainer,
  useNavigationContainerRef,
  createNavigationContainerRef
} from '@react-navigation/native';
import { Linking, Platform, SafeAreaView  , StatusBar } from 'react-native';
import AppRoutes from './navigationApp';
import InterceptorSetup from './api/interceptor';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './lang/i18n';
import { ThemeProvider } from '@shopify/restyle';
import { createDynamicTheme } from './theme';
import { getParameters, StoreKey } from '@voltmoney/micro-frontend';
import { useAppSelector } from './store/hooks'
import AsyncStorage from '@react-native-async-storage/async-storage';
import LogOutUser from './helper/logout';
import { isIframeCheck, trackEvent, useDarkMode } from './utils';
import useDeepLinking from './utils/deepLinking/deepLinking';
const isReadyRef = { current: false };
const routesMap = {
  FLEXI_PAY:"principal",
  INTEREST_PAYMENT:"interest",
  SHORTFALL_REPAY:"shortfall",
}

InterceptorSetup();
const NewApp = ({ extraProps }: { extraProps: any }) => {
  const { routingSupport, setRoutingSupport, setIsUserLoggedIn , startWithOldArch } = extraProps;
  const navigationRef = useNavigationContainerRef();
  const routeNameRef = useRef();
  const auth = useAppSelector(state => state.auth);

  const isDarkMode = useDarkMode();
  let primaryColor = null;
  if(Platform.OS === 'web'){
    primaryColor = getParameters(window?.location?.href).primaryColor;
  }

  const theme = useMemo(
    () => createDynamicTheme('core', isDarkMode ? 'dark' : 'light',primaryColor),
    [],
  );

  useEffect(() => {
    isReadyRef.current = true;
    return () => {
        isReadyRef.current = false;
    };
  }, []);

  const handleDeepLink = useCallback((params: Record<string, any>) => {
    if (
      params &&
      isReadyRef.current &&
      params.screen
    ) {
      // @ts-expect-error
      navigationRef.navigate(params.screen, params);
    }
  }, [isReadyRef.current, navigationRef]);

  useDeepLinking(handleDeepLink);

  return (
    <ThemeProvider theme={theme}>
      <SafeAreaView style={{ flex: 1 }}>
        <NavigationContainer
          ref={navigationRef}
          onReady={()=>(isReadyRef.current = true)}
          onStateChange={async () => {
            const previousRouteName = routeNameRef?.current;
            const currentRouteName = navigationRef?.getCurrentRoute()?.name;
            if (previousRouteName !== currentRouteName) {
              // Save the current route name for later comparison
              routeNameRef.current = currentRouteName;
              
              // Replace the line below to add the tracker from a mobile analytics SDK
              trackEvent(`${currentRouteName}_PAGE_VIEWED`,{source:routesMap[previousRouteName]??previousRouteName});
            }
            console.log('current new arch route', navigationRef?.getCurrentRoute()?.name)
          }}
          onUnhandledAction={async (action: any) => {
            setIsUserLoggedIn(auth?.userDetails);
            console.log(
              'Unhandled action',
              action.payload.name,
              action.payload.params,
            );
            let accessToken = null
            if(Platform.OS === 'web'){
              const isAccessTokenInCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('access_token='));
              if(isAccessTokenInCookiPreset){
                const accessTokenCookie = document.cookie.split(';').find((item) => item.trim().startsWith('access_token='));
                accessToken = accessTokenCookie?.split('=')[1];
              }
              if(!isAccessTokenInCookiPreset && isIframeCheck()){
                accessToken = await AsyncStorage.getItem('access_token');
                if(Boolean(accessToken)){
               }
              }
            }else{
             accessToken = await AsyncStorage.getItem(StoreKey.accessToken);
            }
            if(accessToken){
            setRoutingSupport({
              renderNewArch: false,
              routeName: 'SPLASH_SCREEN',
              params: action.payload.params,
            });
          }
          else{
            LogOutUser()
          }
          }}
        >
          <I18nextProvider i18n={i18n}>
            <StatusBar
              barStyle="default"
            />
            <AppRoutes setIsUserLoggedIn={setIsUserLoggedIn} startWithOldArch={startWithOldArch}/>
          </I18nextProvider>
        </NavigationContainer>
      </SafeAreaView>
    </ThemeProvider>
  );
};
export default NewApp;
